/* eslint-disable */
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// Importa Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.css';
// Importa Bootstrap Icons
import 'bootstrap-icons/font/bootstrap-icons.css';

// Importa BootstrapVue3
import { BootstrapVue3 } from 'bootstrap-vue-3';
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';

// Importa Bootstrap JS
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const app = createApp(App);

app.use(router);
app.use(store);
app.use(BootstrapVue3);

app.mount('#app');
